import c from './styles.module.scss'
import Container from '../container'
import Breadcrumbs from '../breadcrumbs'

const PageHeader = ({title = '', afterTitle = '', after = null, breadcrumbs = [], titleTag: TitleTag = 'h2'}) => {
    return (
        <div className={c.pageHeader}>
            <Container>
                <div className={c.inner}>
                    <div className={c.titleWrapper}>
                        <TitleTag className={[c.title, 'h3'].join(' ')}>{title}{afterTitle ? <span> {afterTitle}</span> : null}</TitleTag>
                        { breadcrumbs ? <Breadcrumbs path={breadcrumbs}/> : null }
                    </div>
                    {after ? <div className={c.after}>{after}</div> : null}
                </div>
            </Container>
        </div>
    )
}

export default PageHeader
